import axios from 'axios';

export const GET_JOBS = 'jobs';

export function getJobsSection(courseProjectGuid, sectionGuid) {
  return axios.get(GET_JOBS, { params: { courseProjectGuid: courseProjectGuid, sectionGuid: sectionGuid } });
}

export function putJob(jobGuid, params) {
  return axios.put('front/' + GET_JOBS + '/' + jobGuid, params);
}

export function getJob(jobGuid, courseGuid, lessonItemGuid) {
  return axios.get('front/' + GET_JOBS + '/' + jobGuid + `?course=${courseGuid}&lessonItem=${lessonItemGuid}`);
}

export function addCommentToJob(params) {
  return axios.post('front/' + GET_JOBS + '/' + params.job_guid + `/comments?course=${params.courseGuid}&lessonItem=${params.lessonItemGuid}`, params);
}

export function deleteComentFromJob(params) {
  return axios.delete('front/' + GET_JOBS + '/' + params.job_guid + `/comments?course=${params.courseGuid}&lessonItem=${params.lessonItemGuid}`, {
    data: { guid: params.comments },
  });
}

export function getJobAttempts(jobGuid) {
  return axios.get('lms/' + GET_JOBS + '/' + jobGuid + '/attempts');
}

export function createNewAttempt(jobGuid, courseGuid, lessonItemGuid) {
  return axios.put('lms/' + GET_JOBS + '/' + jobGuid + `/attempts?course=${courseGuid}&lessonItem=${lessonItemGuid}`, { job_guid: jobGuid });
}
